import { matchPath } from 'react-router';

import { Route } from '../../../../typings/configs';

export const isInternalPath = (testPath: string, bundleTree: Route[]) => {
    return bundleTree.some(({ path, exact }) => {
        return matchPath(testPath, { path, exact });
    });
};
